'use client';

import React, { useEffect, useRef } from 'react';

import RichText from '@/components/ui/RichText/RichText';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { TextContent } from '@/types/richTextTypes';

const IFRAME_ID = '0yljm2ew';

const IFRAME_SRC =
  'https://www.doctify.com/wv2/average-carousel-rating-widget?containerId=0yljm2ew&dotsArrowsColor=4C5870&language=en&profileType=practice&slugs=lips-battersea-power-station&tenantId=athena-uk&theme=transparent&widgetName=average-carousel-rating-widget';

const RESIZE_MESSAGE_TYPE =
  'iframe-resize_average-carousel-rating-widget_0yljm2ew';

const isTrustedDoctifyOrigin = (origin: string) => {
  try {
    const url = new URL(origin);
    return (
      url.protocol === 'https:' &&
      (url.hostname === 'doctify.com' || url.hostname.endsWith('.doctify.com'))
    );
  } catch {
    return false;
  }
};

const ClinicDoctifyRatingCarousel: React.FC<{ data?: TextContent }> = ({
  data,
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { ref, sectionClasses } = useScrollAnimation();

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const handleMessage = (event: MessageEvent) => {
      if (
        event.source !== iframe.contentWindow ||
        !isTrustedDoctifyOrigin(event.origin) ||
        event.data?.type !== RESIZE_MESSAGE_TYPE ||
        typeof event.data.height !== 'string'
      ) {
        return;
      }

      iframe.style.height = event.data.height;
    };

    window.addEventListener('message', handleMessage);
    iframe.src = IFRAME_SRC;

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <section ref={ref} className={sectionClasses}>
      <RichText
        className="flex flex-col items-center justify-center"
        styles={
          data?.styles || {
            p: 'mt-8 md:mt-10 text-theme-primary-dark text-h2',
          }
        }
      >
        {data?.content || 'Latest Patient Reviews'}
      </RichText>
      <div className="mt-4">
        <div className="content_wrapper">
          <iframe
            ref={iframeRef}
            id={IFRAME_ID}
            className="doctify-widget"
            width="100%"
            frameBorder="0"
            scrolling="no"
            name="average-carousel-rating-widget"
            title="Doctify Rating Carousel"
          />
        </div>
      </div>
    </section>
  );
};

export default ClinicDoctifyRatingCarousel;
